function ManageApplication(roleApplication: any, can: any) {
  if (roleApplication) {
    if (roleApplication.manageRole) can("access", "Edit_User_Role");
    if (roleApplication.manageUser) can("access", "User_Setting_Menu");
    if (roleApplication.peakAccount) can("access", "PeakAccount");
    if (roleApplication.peakEngine) can("access", "OldPeak");
    if (roleApplication.peakAsset) can("access", "PeakAsset");
    if (roleApplication.peakBoard) can("access", "PeakBoard");
    if (roleApplication.peakPayroll) can("access", "PeakPayroll");
    if (roleApplication.peakTax) can("access", "PeakTax");
  }
}
export { ManageApplication };
